<template>
  <div
    id="apaasPreviewImageWrapper" class="wrapper"
    :style="styleOptions.wrapperStyle"
  >
    <img
      id="apaasPreviewImage"
      :src="href"
      @click.stop
      alt=""
      draggable="false"
      :class="isShowDrag? 'drag' :''"
      :style="styleOptions.imageStyle"
    />
  </div>
</template>

<script>
export default {
  name: "AtomImagePreview",
  props: {
    href: {
      type: String,
      default:
        "https://s1.vika.cn/space/2020/11/09/88244fe2aa214c3092eb34c78cff0e2c",
    },
    title: {
      type: String,
      default: "预览图",
    },
    isShowDrag: {
      type: Boolean,
      default: false
    },
    styleOptions: {
      type: Object,
      default: () => {
        return {
          imageStyle: {},
          wrapperStyle: {},
        };
      },
    },
  },

};
</script>

<style scoped lang="less">
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;

  img {
    max-width: 100%;
    max-height: 100%;
    transition: transform 0.8s;
  }
}
  .drag{
    cursor: grab;
  }
</style>
